import React from 'react'
import { Box, Card, CardContent, Chip, LinearProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { AnimatedSection, AnimatedTableRow } from '../../components/animations/MotionContainers'
import { useAuth } from '../../context/AuthContext'
import { getUserRecentActivity } from '../../services/apis'
import { getApiErrorMessage } from '../../utils/apiData'
import { getUsuarioFromSession } from '../../utils/permisos'

export const UserRecentAccesses = () => {
  const { session } = useAuth()
  const user = getUsuarioFromSession(session)
  const [activityRows, setActivityRows] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  React.useEffect(() => {
    let active = true

    const loadActivity = async () => {
      setLoading(true)
      setErrorMessage('')

      try {
        const rows = await getUserRecentActivity({ session, userId: user?.id, limit: 25 })
        if (active) setActivityRows(rows)
      } catch (error) {
        if (active) {
          setActivityRows([])
          setErrorMessage(getApiErrorMessage(error, 'No se ha podido cargar el historial de actividad.'))
        }
      } finally {
        if (active) setLoading(false)
      }
    }

    loadActivity()

    return () => {
      active = false
    }
  }, [session, user?.id])

  return (
    <Box className="page-fade">
      <Box className="page-heading suite-page-heading-row">
        <Box>
          <Typography variant="h4">Accesos recientes</Typography>
          <Typography>Consulta tu actividad reciente dentro de las aplicaciones de la suite.</Typography>
        </Box>
        <Chip className="suite-status-chip" label={`${activityRows.length} accesos`} />
      </Box>

      <AnimatedSection><Card className="activity-card suite-view-card">
        <CardContent>
          <Typography className="section-title">Historial de actividad</Typography>
          {loading && <LinearProgress sx={{ mb: 1.5 }} />}
          <Box className="activity-table-wrap">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Aplicación</TableCell>
                  <TableCell>Módulo</TableCell>
                  <TableCell>Fecha y hora</TableCell>
                  <TableCell>Acción</TableCell>
                  <TableCell align="right" />
                </TableRow>
              </TableHead>
              <TableBody>
                {activityRows.map((row) => (
                  <TableRow component={AnimatedTableRow} key={`${row.app}-${row.date}-${row.action}`} hover>
                    <TableCell>
                      <Box className="activity-app-cell">
                        <Box className="activity-row-icon">{row.icon}</Box>
                        <Typography>{row.app}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{row.module}</TableCell>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.action}</TableCell>
                    <TableCell align="right">
                      <ArrowForwardRoundedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                    </TableCell>
                  </TableRow>
                ))}
                {!loading && activityRows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography className="admin-user-empty">{errorMessage || 'No hay actividad reciente.'}</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </CardContent>
      </Card></AnimatedSection>
    </Box>
  )
}
